angular.module('workflow')
    .component('workflowBtnOptions', {
        bindings: {
            item: '<',
            largeButton: '<'
        },
        templateUrl: 'app/workflow/_btn-options.html',
        controller: function ($rootScope, WorkflowService, Principal, FilesSimpleUploadService, FilesLibrary) {
            this.WorkflowService = WorkflowService
            this.FilesLibrary = FilesLibrary
            this.FilesSimpleUploadService = FilesSimpleUploadService

            this.fileResourceName = 'WORKFLOW'

            this.$onChanges = () => {
                this.isManager = Principal.hasAnyAuthority(["ROLE_WORKFLOW_ALL"]);
                this.canDelete = this.isManager;
                Principal.currentUser().then(user => {
                    this.canPass = this.isManager || this.item.worker.id === user.id;
                    this.canEdit = this.isManager || this.item.worker.id === user.id;
                    this.canManageFiles = this.isManager || this.item.worker.id === user.id
                })
            }

            this.attachFile = () => FilesSimpleUploadService.open({type: this.fileResourceName, id: this.item.id}).then(() => $rootScope.$broadcast('workflow.updated'));
            this.attachLibraryFile = () => FilesLibrary.openAndBind({type: this.fileResourceName, id: this.item.id}).then(() => $rootScope.$broadcast('workflow.updated'));
        }
    })
